import React from "react";
import axios from "axios";
import PropTypes from "prop-types";
import { Redirect } from "react-router-dom";
import Api from "../../assets/js/utils/Api";
import LoaderComponent from "../components/Loader";
import Button from "../components/CustomButtons/Button.jsx";
import GridContainer from "../components/Grid/GridContainer.jsx";
import GridItem from "../components/Grid/GridItem.jsx";
import Card from "../components/Card/Card.jsx";
import CardBody from "../components/Card/CardBody.jsx";
import CardIcon from "../components/Card/CardIcon.jsx";
import CardHeader from "../components/Card/CardHeader.jsx";
import FolderIcon from "@material-ui/icons/Folder";
import DownloadIcon from '@material-ui/icons/CloudDownloadOutlined';
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import withStyles from "@material-ui/core/styles/withStyles";
import settingsPageStyle from "../../assets/jss/settingsPageStyle";
import { helper } from "../../assets/js/utils/Element.js";

class DownloadFiles extends React.Component {
    constructor(props){
        super(props);

        this.store = this.props.store;

        this.state = {
            cancelToken: null,
            loading: false,
            filesTree: [],
            expanded: {},
            currentPath: []
        };
    }

    componentDidMount(){
        this.loadFiles();
    }

    componentWillUnmount(){
        if (this.state.cancelToken) {
            this.state.cancelToken.cancel("Request Cancelled");
        }
    }

    loadFiles(){
        const source = axios.CancelToken.source();
        this.setState({ loading: true, cancelToken: source });

        Api.getDownloadFiles({}, source).then(data => {
            this.setState({
                filesTree: data,
                loading: false,
                cancelToken: null
            });
        }).catch(() => {
            this.setState({ loading: false });
        });
    }

    toggleFolder(path){
        this.setState(prev => ({
            expanded: {
                ...prev.expanded,
                [path]: !prev.expanded[path]
            }
        }));
    }

    deleteFile(path){
        if(!window.confirm("Delete permanently?")){
            return;
        }

        const source = axios.CancelToken.source();

        Api.deleteDownloadFile({ path }, source).then(() => {
            const updatedTree = this.removeNode(this.state.filesTree, path);
            this.setState({ filesTree: updatedTree });
        });
    }

    removeNode(nodes, path){
        return nodes
            .filter(node => node.path !== path)
            .map(node => {
                if(node.children){
                    node.children = this.removeNode(node.children, path);
                }
                return node;
            });
    }

    renderTree(nodes, level = 0){
        if(!nodes || nodes.length === 0){
            return null;
        }

        return (
            <ul style={{ listStyle: "none", paddingLeft: level === 0 ? 0 : 20 }}>
                {nodes.map((node, index) => {
                    const isExpanded = this.state.expanded[node.path];
                    const hasChildren = node.children && node.children.length > 0;
                    let isOdd = index % 2 === 0;

                    if(node.type === "folder"){
                        return (
                            <li key={index} style={{ marginBottom: 6, backgroundColor: isOdd ? "rgba(0,0,0,.03)" : "#fff", padding: "4px 8px", borderRadius: 4 }}>
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        cursor: hasChildren ? "pointer" : "default",
                                        fontWeight: 600
                                    }}
                                    onClick={() => hasChildren && this.toggleFolder(node.path)}
                                >
                                    {hasChildren && (
                                        <span style={{
                                            display: "inline-block",
                                            width: 15,
                                            textAlign: "center",
                                            marginRight: 5
                                        }}>
                                            {isExpanded ? "-" : "+"}
                                        </span>
                                    )}

                                    {!hasChildren && <span style={{ width: 15, marginRight: 5 }}></span>}

                                    <FolderIcon style={{ marginRight: 6 }} />
                                    <span>{node.name}</span>
                                    <span style={{ marginLeft: 10, color: "#999" }}>
                                        ({helper.getFormatedSize(node.size)})
                                    </span>

                                    <Button
                                        color="danger"
                                        size="sm"
                                        style={{ marginLeft: "auto" }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            this.deleteFile(node.path);
                                        }}
                                    >
                                        Delete
                                    </Button>
                                </div>

                                {isExpanded && this.renderTree(node.children, level+1)}
                            </li>
                        );
                    }

                    if(node.type === "file"){
                        return (
                            <li key={index} style={{ marginBottom: 6, backgroundColor: isOdd ? "rgba(0,0,0,.03)" : "rgba(0,0,0,.03)", padding: "4px 8px", borderRadius: 4 }}>
                                <div style={{
                                    display: "flex",
                                    alignItems: "center"
                                }}>
                                    <span style={{ width: 20 }}></span>
                                    <InsertDriveFileIcon style={{ marginRight: 6 }} />

                                    <a
                                        href={node.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {node.name}
                                    </a>

                                    <span style={{ marginLeft: 10, color: "#999" }}>
                                        ({helper.getFormatedSize(node.size)})
                                    </span>

                                    <Button
                                        color="danger"
                                        size="sm"
                                        style={{ marginLeft: "auto" }}
                                        onClick={() => this.deleteFile(node.path)}
                                    >
                                        Delete
                                    </Button>
                                </div>
                            </li>
                        );
                    }

                    return null;
                })}
            </ul>
        );
    }

    render(){
        const { classes } = this.props;
        const { loading, filesTree } = this.state;
        const { authorized } = this.store.getState();

        if(!authorized){
            return <Redirect to="/auth/login" />
        }

        return (
            <GridContainer>
                <GridItem xs={12}>
                    <Card>
                        <CardHeader color="rose" icon>
                            <CardIcon color="rose">
                                <DownloadIcon />
                            </CardIcon>
                            <h4 className={classes.cardIconTitle}>
                                Download Files
                            </h4>
                        </CardHeader>

                        <CardBody>
                            {loading ? <LoaderComponent align="left" /> : this.renderTree(filesTree)}
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
        );
    }
}

DownloadFiles.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(settingsPageStyle)(DownloadFiles);